export interface ImoGenericItemDto {
  ResultsPerPage: number | null;

  // number of Did you mean? results
  DymSize: number | null;

  Page: number | null;

  FilterByPrecedence: ImoFilterPrecedence | null;

  SearchQuery: string;

  // try to avoid using this, because it requires you to directly refer
  // to imo properties that aren't exposed in this service
  FilterByExpression: string | null;

  DistinctByFields: string[];

  PatientAge: number | null;

  PatientGender: ImoGender | null;

  LexicalCodes: string[];

  CountOnly: boolean;

  UsePreviousVersion: boolean;

  HccModalFiltered: boolean;
}

export enum ImoFilterPrecedence {
  And = 'And',
  Or = 'Or',
  Override = 'Override',
}

export enum ImoGender {
  M = 'M',
  F = 'F',
}
